// Components
import { CardProps } from '../../atoms/Card/Card';
import ToGoPill from '../../atoms/ToGoPill/ToGoPill';

// Styles
import styles from './ToGoList.module.css';

/**
 * @function ToGoList
 * Provides a container for ToGoPills
 *
 * @example
 * return (
 *   <ToGoList cards={[]} />
 * )
 */
function ToGoList({ cards }: ToGoListProps): JSX.Element {
    return (
        <section className={styles.container}>
            {[...Array(4)].map((item, index) => {
                const name = index + 1;
                const count = cards.filter(
                    ({ remaining }) => remaining === name,
                ).length;
                return <ToGoPill key={name} name={name} count={count} />;
            })}
        </section>
    );
}

/**
 * @interface ToGoListProps
 * Describes the properties required for the ToGoList component
 *
 * @property {array} cards List of cards
 * @property {array} called List of called numbers in draw sequence
 * @property {array} patterns List of patterns and their variants
 */
interface ToGoListProps {
    cards: CardProps[];
}

// Exports
export default ToGoList;
